import Vue from 'vue';
import Router from 'vue-router';

import Login from './components/Login.vue';
import Registration from './components/Registration.vue';
import CourseStep from './components/CourseStep.vue';

Vue.use(Router);

export default function setupRouter(mode = 'history') {
  const router = new Router({
    mode,
    base: process.env.BASE_URL,
    routes: [
      { path: '/logout', meta: { logout: true } },
      { path: '/login', component: Login, meta: { auth: false } },
      { path: '/registration', component: Registration, meta: { auth: false } },
      { path: '/:module/:step?', component: CourseStep, meta: { auth: true } },
      { path: '/', redirect: '/login' },
    ],
  });

  /**
   * Middleware
   */
  router.beforeEach((to, from, next) => {
    if (to.matched.some(record => Object.prototype.hasOwnProperty.call(record.meta, 'logout'))) {
      localStorage.removeItem('jwtToken');
      return next('/login');
    }

    if (to.matched.some(record => Object.prototype.hasOwnProperty.call(record.meta, 'auth'))) {
      const logged = localStorage.getItem('jwtToken');

      if (to.meta.auth && !logged) {
        return next('/login');
      }

      if (!to.meta.auth && logged) {
        return next('/module-1');
      }
    }

    return next();
  });

  return router;
}
